import api from '@/shared/utils/apiConfig';

import type { TreatmentCatalogActorRef } from './treatmentCategory.api';

export interface TreatmentUom {
  id: string;
  code: string;
  name: string;
  isSystem: boolean;
  isActive: boolean;
  sortOrder: number;
  createdBy?: TreatmentCatalogActorRef;
  updatedBy?: TreatmentCatalogActorRef;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTreatmentUomPayload {
  name: string;
  sortOrder?: number;
}

export interface UpdateTreatmentUomPayload {
  name?: string;
  sortOrder?: number;
  isActive?: boolean;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
}

export const treatmentUomAPI = {
  getAll: async (includeInactive = false): Promise<ApiResponse<TreatmentUom[]>> => {
    const response = await api.get('/treatment-uoms', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
  },

  create: async (payload: CreateTreatmentUomPayload): Promise<ApiResponse<TreatmentUom>> => {
    const response = await api.post('/treatment-uoms', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateTreatmentUomPayload
  ): Promise<ApiResponse<TreatmentUom>> => {
    const response = await api.put(`/treatment-uoms/${id}`, payload);
    return response.data;
  },

  deactivate: async (id: string): Promise<ApiResponse<TreatmentUom>> => {
    const response = await api.delete(`/treatment-uoms/${id}`);
    return response.data;
  },
};
